import { makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import { FC } from "react";

import { RequestStatus } from "../types";

const useStyles = makeStyles((theme) => ({
  confirmed: {
    color: theme.palette.success.main,
  },
  canceled: {
    color: theme.palette.error.main,
  },
  pending: {
    color: theme.palette.warning.main,
  },
  firstLetter: {
    "&:first-letter": {
      textTransform: "capitalize",
    },
  },
}));

const RequestsStatusText: FC<any> = (props) => {
  const classes = useStyles({});
  const request = props.record;

  /**
   * show status will be changing after enums change in firestore and css conditions should be change
   */

  return (
    <>
      {request && request.status ? (
        <Typography
          variant="body2"
          className={clsx(
            {
              [classes.confirmed]: request.status === RequestStatus.confirmed,
              [classes.canceled]: request.status === RequestStatus.canceled,
              [classes.pending]: request.status === RequestStatus.pending,
            },
            classes.firstLetter
          )}
        >
          {request.status === RequestStatus.confirmed
            ? RequestStatus.approved
            : request.status === RequestStatus.canceled
            ? RequestStatus.rejected
            : request.status}
        </Typography>
      ) : null}
    </>
  );
};

export default RequestsStatusText;
